<template>
  <div
    class="modal-backdrop modal modal-sheet bg-body-primary"
    tabindex="-1"
    role="dialog"
    id="modalSheet"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content rounded-4 shadow">
        <!-- 添加模式下显示的内容 -->
        <div class="form-container">
          <form @submit.prevent="handleSubmit">
            <!-- 任务详情内容 -->
            <div class="modal-header border-bottom-0 form-group">
              <div class="rounded-line"></div>
              <input
                v-if="!isDetailMode"
                type="text"
                placeholder="Title"
                class="borderless-input"
                v-model="title"
              />
              <input
                v-else
                type="text"
                class="borderless-input disable-control"
                :value="task.title"
                disabled
              />
              <button
                type="button"
                class="btn-close"
                aria-label="Close"
                @click="closeModal"
              ></button>
            </div>

            <div class="form-group" v-if="!isDetailMode">
              <label for="startTime" class="col-form-label">Time</label>
              <vue-date-picker
                v-model="startTime"
                :config="config"
                class="col size-control"
              ></vue-date-picker>
              <span><i class="bi bi-chevron-right iconsize-control"></i></span>
              <vue-date-picker
                v-model="endTime"
                :config="config"
                class="col size-control"
              ></vue-date-picker>
            </div>
            <div v-else class="form-group">
              <label for="startTime" class="col-form-label">Time</label>
              <input
                type="text"
                class="form-control col size-control disable-control"
                :value="formatDate(task.startTime, 'yyyy-MM-dd HH:mm')"
                disabled
              />
              <span><i class="bi bi-chevron-right iconsize-control"></i></span>
              <input
                type="text"
                class="form-control col size-control disable-control"
                :value="formatDate(task.endTime, 'yyyy-MM-dd HH:mm')"
                disabled
              />
            </div>

            <div class="form-group">
              <label for="category" class="col-form-label">Category</label>

              <select
                v-if="!isDetailMode"
                class="form-select choose-control"
                v-model="selectedCategory"
              >
                <option
                  v-for="category in categories"
                  :key="category.id"
                  :value="category.name"
                >
                  {{ category.name }}
                </option>
              </select>

              <!-- 在详情模式下仅显示选中的类别名称 -->
              <span v-else class="badge badge-soft-success mb-0">{{
                task.category
              }}</span>
            </div>
          </form>
        </div>
        <div v-if="!isDetailMode" class="button-controll">
          <BaseButton class="button-detail" color="GRAY" @click="cancelEdit"
            >CANCEL</BaseButton
          >
          <BaseButton class="button-detail" color="PURPLE" @click="confirmEdit"
            >COMFIRM</BaseButton
          >
        </div>

        <!-- 当在详情模式下时，根据计时状态显示不同的图标 -->
        <div v-else class="icon-control">
          <i
            v-if="!isTiming"
            class="bi bi-play-circle-fill"
            @click="startTiming"
          ></i>
          <i v-else class="bi bi-stop-circle-fill" @click="stopTiming"></i>
        </div>
      </div>
    </div>
    <BasicAlert :visible="showAlert" message="Please Check Your Form!" />
  </div>
</template>

<script>
import BaseButton from "@/components/global/BaseButton.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import BasicAlert from "@/components/global/BasicAlert.vue"; // 确保您已创建此组件
import { format } from "date-fns";

export default {
  components: {
    BaseButton,
    VueDatePicker,
    BasicAlert,
  },
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    isDetailMode: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: () => [], // 添加这行代码来接收分类数据
    },
  },
  data() {
    return {
      selectedCategory: null, // 默认选中的类别
      title: "",
      startTime: null,
      endTime: null,
      config: {
        format: "YYYY-MM-DD HH:mm",
        is24hr: true,
      },
      showAlert: false,
      isTiming: false, // 用于追踪任务是否正在进行
      punchInTime: null, // 记录开始时间
      punchOutTime: null, // 记录结束时间
    };
  },
  watch: {
    task: {
      handler(newValue) {
        if (newValue && this.isDetailMode) {
          this.startTime = new Date(newValue.startTime);
          this.endTime = new Date(newValue.endTime);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.task && this.isDetailMode) {
      this.startTime = new Date(this.task.startTime);
      this.endTime = new Date(this.task.endTime);
    }
  },
  methods: {
    confirmEdit() {
      if (this.validateInput()) {
        const formattedStartTime = this.formatDate(this.startTime);
        const formattedEndTime = this.formatDate(this.endTime);

        const newTask = {
          title: this.title,
          day: formattedStartTime.split(" ")[0],
          time: `${formattedStartTime.split(" ")[1]} `,
          startTime: formattedStartTime,
          endTime: formattedEndTime,
          category: this.selectedCategory, // 确保这里的selectedCategory是有值的
        };

        console.log(
          "Confirming11 new task with category:",
          this.selectedCategory
        ); // Debugging

        this.$emit("newTaskCreated", newTask);
      }
    },

    formatDate(date, formatStr = "yyyy-MM-dd HH:mm") {
      if (!date) return "";
      try {
        return format(new Date(date), formatStr);
      } catch (error) {
        console.error("Error formatting date:", error);
        return "";
      }
    },
    validateInput() {
      if (!this.title || !this.startTime || !this.endTime) {
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
        return false;
      }
      return true;
    },
    cancelEdit() {
      this.$emit("closeModal");
    },
    closeModal() {
      this.$emit("closeModal");
    },
    startTiming() {
      if (!this.isTiming) {
        this.punchInTime = new Date(); // 记录开始时间
        this.isTiming = true; // 更改状态为正在进行
        this.$emit("update-task", {
          id: this.task.id,
          punchInTime: this.punchInTime,
        });
      }
    },
    calculateWorkingHours() {
      if (this.punchInTime && this.punchOutTime) {
        const diff = this.punchOutTime.getTime() - this.punchInTime.getTime(); // 时间差（毫秒）
        const hours = Math.floor(diff / (1000 * 60 * 60)); // 转换为小时
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)); // 转换为分钟

        // 设置组件状态中的工作小时
        this.workingHours = `${hours}hr ${minutes}min`;
        return hours + minutes / 60; // 返回小时数
      }
      return 0; // 如果没有开始和结束时间，返回0
    },
    stopTiming() {
      if (this.isTiming) {
        this.punchOutTime = new Date(); // 记录结束时间
        this.isTiming = false; // 更改状态为不在进行
        const hours = this.calculateWorkingHours(); // 计算工作时间

        this.calculateWorkingHours(); // 计算工作时间

        // 发射更新任务时间的事件
        this.$emit("updateTaskTiming", {
          id: this.task.id, // 假设每个任务有唯一的ID
          punchInTime: this.punchInTime,
          punchOutTime: this.punchOutTime,
          workingHours: this.workingHours, // 包含计算后的工作小时
        });

        this.$emit("update-task", {
          id: this.task.id,
          punchOutTime: this.punchOutTime,
          workingHours: this.workingHours,
        });

        console.log("Emitting task-ended event");
        // 发射任务结束的事件
        this.$emit("task-ended", {
          title: this.task.title,
          category: this.task.category,
          punchInTime: this.punchInTime,
          punchOutTime: this.punchOutTime,
          workingHours: this.workingHours,
        });
        this.$emit("update-task", {
          title: this.task.title,
          category: this.task.category,
          punchInTime: this.punchInTime,
          punchOutTime: this.punchOutTime,
          workingHours: this.workingHours,
        });
        // 更新 Vuex store 中的最新任务标题
        this.$store.dispatch("setLatestTaskTitle", {
          categoryName: this.task.category,
          taskTitle: this.task.title,
        });
        // 更新 Vuex store 中的类别工作小时总数
        this.$store.commit("updateCategoryHours", {
          categoryId: this.task.categoryId,
          hours: hours,
        });
        // 发射任务结束的事件，包括工作小时
        this.$emit("task-ended", {
          // 任务详情...
          workingHours: this.workingHours,
        });
      }
    },
  },
};
</script>

<style scoped>
body {
  min-height: 100vh !important;
}
.form-group {
  display: flex;
  align-items: center;
  gap: 5px; /* 添加間距 */
}
.form-group .col-form-label {
  flex: 0 0 18%; /* 設置標籤的初始大小 */
  padding-bottom: 15px;
  margin-left: 20px;
}
.iconsize-control {
  font-size: 10px; /* 調整圖標大小 */
  align-self: center; /* 確保圖標垂直居中 */
  margin: 0 2px; /* 調整圖標的左右間距 */
}

.size-control {
  flex-basis: 150px !important; /* 設置初始大小 */
  flex-grow: 0 !important; /* 防止在有多餘空間時擴展 */
  flex-shrink: 0 !important; /* 防止在空間不足時收縮 */
  margin-right: 5px !important; /* 右邊距 */
}

.icon-control {
  justify-content: end !important;
  gap: 0px !important;
  margin: 10px 380px !important;
  padding-top: 13px !important;
  font-size: 1.7rem !important;
}
.modal-header {
  display: flex; /* 启用Flexbox布局 */
  align-items: center; /* 垂直居中对齐子元素 */
  justify-content: flex-start; /* 子元素靠左对齐 */
  border-bottom: 0; /* 移除底部边框 */
}

.rounded-line {
  width: 5px;
  height: 35px;
  background-color: #e2d5ff !important;
  border-radius: px; /* 圆角 */
  margin-right: 10px; /* 添加右边距，与标题之间留出空间 */
  margin: 0 10px 0 0; /* 确保上下边距为0 */
}

.modal-title {
  color: black !important; /* 标题颜色 */
  margin: 0; /* 移除默认外边距 */
  font-size: 30px !important;
}
.modal-content {
  padding-left: 20px !important; /* 调整模态框左边距 */
  width: 500px !important; /* 调整模态框宽度 */
  height: 290px;
}
.borderless-input {
  flex-grow: 1; /* 使輸入匡佔據剩餘空間 */
  border: none; /* 移除边框 */
  outline: none; /* 在聚焦时移除外轮廓线 */
  font-size: x-large;
  font-weight: 450;
  color: #000000;
  padding-bottom: 10px;
}
.badge-soft-success {
  align-self: center; /* 確保類別標籤垂直居中 */
  color: #63ad6f !important;
  background-color: rgba(99, 173, 111, 0.1);
  font-size: 13px;
}

.button-detail {
  flex-direction: row !important;
  margin: 10px 0px 10px 60px !important;
  width: 130px;
  height: 40px;
}

.disable-control {
  background: #ffffff !important;
  border: none;
}
.choose-control {
  width: 330px;
}

.choose-control:focus {
  background-color: #ffffff !important; /* 点击时的背景色 */
  outline: none !important; /* 去除焦点轮廓 */
}
.modal-backdrop {
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
@media (max-width: 576px) {
  /* 对应于手机竖屏 */
  .modal-dialog {
    transform: scale(0.8); /* 缩放卡片大小，根据需要调整 */
    position: absolute;
    top: 0px;
    margin: auto 0; /* 水平居中 */
  }
}
</style>
